export const Views = {
  Profile: 'profile',
  Inbox: 'inbox',
  Archive: 'archive',
  Upload: 'upload',
  Synced: 'synced',
  Settings: 'settings',
  RegistrationSettings: 'registration',
  AddressValidation: 'addressvalidation',
  ReRegistrationSettings: 'reregistration',
  AllSettings: 'all',
  Feed: 'feed',
  Chat: 'chat',
  Goals: 'goals'
};
